import { __assign } from "tslib";
import React from 'react';
import FULLSCREEN_EVENTS from '../constants/fullscreenEvents';
import { isSEOMode } from '../utils/viewModeWrapper';
import { experiments } from '@wix/photography-client-lib';
export default function MobileBottomLink(props) {
    var curItem = props.current.item;
    var shouldShowLink = curItem.hasLink && props.styles.allowLinkExpand;
    if (!shouldShowLink) {
        return null;
    }
    var linkClassNames = 'fullscreen-side-bar-link pro-fullscreen-link pro-fullscreen-store';
    var isSEO = isSEOMode();
    var noFollowForSEO = props.noFollowForSEO;
    var shouldUseNofollow = isSEO && noFollowForSEO;
    var seoLinkParams = shouldUseNofollow ? { rel: 'nofollow' } : {};
    var _a = curItem.directLink || {}, url = _a.url, target = _a.target;
    var shouldUseDirectLink = !!(url && target);
    var onKeyPress = function (e, onClickFunction) {
        switch (e.keyCode || e.charCode) {
            case 32: // space
            case 13: // enter
                e.preventDefault();
                onClickFunction();
                return false;
        }
    };
    if (shouldUseDirectLink) {
        return (React.createElement("a", __assign({ className: linkClassNames, href: url, target: target }, seoLinkParams), curItem.linkText || curItem.linkUrl));
    }
    else {
        return (React.createElement("div", { className: linkClassNames, onClick: function () {
                return props.actions.eventsListener(FULLSCREEN_EVENTS.NAVIGATE, curItem);
            }, onKeyDown: function (e) {
                return onKeyPress(e, function () {
                    return props.actions.eventsListener(FULLSCREEN_EVENTS.NAVIGATE, curItem);
                });
            }, tabIndex: 0 }, curItem.linkText || curItem.linkUrl));
    }
}
//# sourceMappingURL=mobileBottomLink.js.map